import React from 'react';

// estilos
import './buscar.css';
import imgLupa from './lupa.svg';
import PptoBuscar from './../../pptos/PptoBuscar';

export const Buscar = ({ filters, setFilters, title = "presupuestos" }) => {

  const handleChange = ({ target }) => {
    const newFilters = {
      ...filters,
      [target.name]: target.value
    }
    setFilters(newFilters)
  }

  return (
    <div className='p-buscar'>
      <img className='p-buscar-lupa' src={imgLupa} alt="buscar" htmlFor="buscador" />

      <input
        type="text"
        placeholder={`Buscar en ${title}`}
        id='buscador'
        name='text'
        onChange={handleChange}
      />

      <PptoBuscar
        filters={filters}
        setFilters={setFilters}
      />

    </div>
  )
}
